export interface Action {
  type: ActionType;
  recordId: string;
  annotationId?: string;
  redirectUrl?: string;
}

export enum ActionType {
  ADD_FAVORITE,
  ADD_TO_LIST,
  CHECKOUT,
  DOWNLOAD,
  OPEN_EXTERNAL,
  FOLLOW,
  HOLD,
  OPEN_ANNOTATION,
  NONE,
}
